



















































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {BFormFile, BProgress, BButton, BFormCheckbox} from "bootstrap-vue";
import RessifnetQuillEditor from "@/components/inputs/RessifnetQuillEditor.vue";
import RessifnetDateInput from "@/components/inputs/RessifnetDateInput.vue";
import { DemandeAideFinanciere } from "@/api/models/dossiers/demandesAideFinanciere/demandeAideFinanciere";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import {TypeAideFinanciere} from "@/api/models/dossiers/typeAideFinanciere";
import { PaginatedList } from "@/api/models/common/paginatedList";

@Component({
  components: {
  RessifnetQuillEditor,
  BFormFile,
  BButton,
  BProgress,
  BFormCheckbox,
  RessifnetDateInput,
  SearchableVueSelect
  },
})
export default class DetailsDemandeAideFinanciere extends Vue {
  @Prop({ required: true }) demandeId!: string | null

  demandeEdited: DemandeAideFinanciere = {};
  fichiersUploaded = [];
  percentUpload: number = 0;
  listTypeAideFinanciere: TypeAideFinanciere[] = []


  
  onUploadProgress(percent: any) {
    this.percentUpload = percent;
  }

  @Watch('demandeId')
  async demandeIdChanged() {
    if (this.demandeId) {
      await this.$http.ressifnet.demandesAideFinanciere
        .getById(this.$route.params.id, this.demandeId)
        .then((demandeAideFinanciere : any) => {
        this.demandeEdited = { 
            ...demandeAideFinanciere,
            fichiers: []
        };
        this.fichiersUploaded = demandeAideFinanciere.fichiers;
        })
    }
    else {
    this.demandeEdited = {}
    this.fichiersUploaded = []
    }
  }

  async created() {
    await this.loadListTypesAideFinanciere()
    if (this.demandeId) {
      await this.$http.ressifnet.demandesAideFinanciere
        .getById(this.$route.params.id, this.demandeId)
        .then((demandeAideFinanciere : any) => {
        this.demandeEdited = { 
            ...demandeAideFinanciere,
            fichiers: []
        };
        this.fichiersUploaded = demandeAideFinanciere.fichiers;
      })
    }
  }

  get fichiers() {
    var files = [];

    if (this.demandeEdited.fichiers && this.demandeEdited.fichiers.length > 0) {
      files = this.demandeEdited
        .fichiers.filter((f: any) => f.id == undefined)
        .map(
          (x: File) =>
            <any>{
              nom: x.name,
            }
        );
    }
    return files.concat(this.fichiersUploaded);
  }

  async downloadFile(fichier:any) {
    if (!fichier.id)
      return;
    else {
      await this.$http.ressifnet.fichiersDossiers
        .downloadFile(fichier.id)
        .then(
          async (response: any) => {
            window.open(response);
          },
          (error: any) => {
            if (error?.response?.data?.errors) {
              errorAlert.fire({
                text: error.response.data.errors[
                  Object.keys(error.response.data.errors)[0]
                ],
              });
            } else {
              errorAlert.fire({
                text: error.message,
              });
            }
          }
        );
    }
  }

  async loadListTypesAideFinanciere() {
    await this.$http.ressifnet.typesAidesFinanciere
      .paginatedList(1, 100, true)
      .then((res: PaginatedList<TypeAideFinanciere>) => {
        this.listTypeAideFinanciere = res.items;
      }) 
  }

  closeDetails() {
    this.demandeEdited = {
      fichiers : [],
    }
    this.$emit('close-details')
  }

  async save(callback: any) {
    let config = {
      onUploadProgress(progressEvent: any) {
        var percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );

        callback(percentCompleted);
        return percentCompleted;
      },
    };

    if (this.demandeEdited.id) {
      await this.$http.ressifnet.demandesAideFinanciere
        .put(this.$route.params.id, this.demandeEdited.id, this.demandeEdited, config)
        .then(
          (response: any) => {
            this.$emit('reloadDossier');
            this.$emit('reloadNotes');
            this.$emit('reloadFiles');
            successAlert.fire({
              title: "Modification d'une demande d\'aide financiere",
              text: "Modification effectué avec succès",
            });
            this.percentUpload = 0;
          },
          (error: any) => {
            if (
              error?.response?.data?.errors &&
              Object.keys(error.response.data.errors).length
            ) {
              errorAlert.fire({
                text: error.response.data.errors[
                  Object.keys(error.response.data.errors)[0]
                ],
              });
            } else {
              errorAlert.fire({
                text: error?.response?.data?.detail ?? error.message,
              });
            }
            this.percentUpload = 0;
          }
        );
        this.closeDetails()
    }
    else {
      
      let config = {
        onUploadProgress(progressEvent: any) {
          var percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );

          callback(percentCompleted);
          return percentCompleted;
        },
      };
      await this.$http.ressifnet.demandesAideFinanciere.post(this.$route.params.id, this.demandeEdited, config)
        .then(
          (response: any) => {
            this.$emit('reloadDossier');
            this.percentUpload = 0;
            successAlert.fire({
              title: "Ajout d'une demande d\'aide financière",
              text: "Ajout effectué avec succès",
            });
            
            this.percentUpload = 0;
            this.$emit('reloadNotes');
          },
          (error: any) => {
            if (
              error?.response?.data?.errors &&
              Object.keys(error.response.data.errors).length
            ) {
              errorAlert.fire({
                text: error.response.data.errors[
                  Object.keys(error.response.data.errors)[0]
                ],
              });
            } else {
              errorAlert.fire({
                text: error?.response?.data?.detail ?? error.message,
              });
            }
          }
        );
        this.closeDetails()
    }  
    this.$emit('reload-list')
  }
    removeFichier(fichier: any) {
    if (fichier.id != undefined) {
      this.$bvModal
        .msgBoxConfirm(
          "Etes-vous sûr de vouloir supprimer ce fichier de la demande d\'aide financière ? Cela le supprimera directement",
          {
            title: "Confirmation de suppression",
            size: "sm",
            okVariant: "primary",
            okTitle: "Oui",
            cancelTitle: "Non",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then(async (value) => {
          if (value === true) {
            this.confirmRemoveFichier(fichier);
          } else {
            return;
          }
        });
    } else {
      this.demandeEdited.fichiers!.splice(
        (this.demandeEdited.fichiers! as any[]).indexOf(fichier),
        1
      );
    }
  }

    async confirmRemoveFichier(fichier: any) {
    await this.$http.ressifnet.demandesAideFinanciere
      .deleteFile(
        this.$route.params.id,
        (this.demandeEdited as any).id,
        fichier.id
      )
      .then((res: any) => {
        this.$emit('reloadDossier');
        this.$emit('reload-list')
        successAlert.fire({
          title: "Suppression d'un document",
          text: "Suppression effectuée avec succès",
        });

        (this.demandeEdited.fichiers! as any[]).push({ id: fichier.id });
        this.fichiersUploaded.splice(
          (this.fichiersUploaded as any[]).indexOf(fichier),
          1
        );
      });
  }
    
}
